import React from 'react';

import { TextField } from '@gogame/components';
import { withFormField, omitFormProps } from '@gogame/form';

const SizeTextField = withFormField({
  debounceTimeout: 300,
})(({ value, onChange, ...props }) => {
  const handleChange = (e, newValue) => {
    onChange(e, newValue);
  };
  return (
    <TextField
      value={value}
      onChange={handleChange}
      {...omitFormProps(props)}
    />
  );
});
export default SizeTextField;
